<script>
import baseMixin from '@/mixins/baseMixin'
import { mapGetters } from 'vuex'

export default {
  name: 'BookingPendingApprovalsDetailsStatusLabel',
  mixins: [baseMixin],
  computed: {
    ...mapGetters({
      activeBooking: 'bookingApprovals/activeBooking',
    }),
    compStatusText() {
      switch (this.activeBooking?.status) {
        case 'pendingApproval':
          return 'Pending Approval'
        default:
          return ''
      }
    },
  },
}
</script>

<template>
  <v-chip>
    {{ compStatusText }}
  </v-chip>
</template>
